import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseDirective } from './base.directive';
import { AnimationLoader } from './animation-loader';
import { LottieDirective } from './lottie.directive';
import { LottieComponent } from './lottie.component';
import { LOTTIE_OPTIONS } from './symbols';
export class LottieModule {
    static forRoot(options) {
        return {
            ngModule: LottieModule,
            providers: [
                AnimationLoader,
                {
                    provide: LOTTIE_OPTIONS,
                    useValue: options,
                },
            ],
        };
    }
}
LottieModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [BaseDirective, LottieDirective, LottieComponent],
                exports: [BaseDirective, LottieDirective, LottieComponent],
            },] }
];
//# sourceMappingURL=lottie.module.js.map